import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action, computed, makeObservable } from "mobx";
import { ItemSearchProviders } from "../Models/ItemSearchProviders/ItemSearchProviders";
/**
 * This mixin adds capability for searching a catalog item using an {@link
 * ItemSearchProvider}.
 */
function SearchableItemMixin(Base) {
  var _class;
  let SearchableItemMixin = (_class = class SearchableItemMixin extends Base {
    /**
     * A hook for highlighting features in item search results.
     *
     * @param results The search results to be highlighted.
     */

    /**
     * A hook for hiding features not in item search results.
     *
     * @param results The search results to be hidden.
     */

    /**
     * A method implementing zoom to behavior for results.
     *
     */

    constructor() {
      super(...arguments);
      _defineProperty(this, "hasSearchableItemMixin", true);
      makeObservable(this);
    }

    /**
     * Returns true if this item is searchable and has a valid item search provider defined.
     */
    get canSearch() {
      return this.search.providerType ? ItemSearchProviders.has(this.search.providerType) : false;
    }

    /**
     * Returns an instance of the ItemSearchProvider for searching the item.
     */
    createItemSearchProvider() {
      const klass = this.search.providerType && ItemSearchProviders.get(this.search.providerType);
      if (!klass) return;
      return new klass(this.search.providerOptions, this.search.parameters);
    }
  }, _applyDecoratedDescriptor(_class.prototype, "canSearch", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createItemSearchProvider", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createItemSearchProvider"), _class.prototype), _class);
  return SearchableItemMixin;
}
(function (_SearchableItemMixin2) {
  function isMixedInto(model) {
    return model && model.hasSearchableItemMixin;
  }
  _SearchableItemMixin2.isMixedInto = isMixedInto;
})(SearchableItemMixin || (SearchableItemMixin = {}));
export default SearchableItemMixin;